import { z } from 'zod';
import { DEFAULT_COUNTRY_CODES } from '@repo/design-system-kit/constants/countries';

export const countriesEnum = z.enum(DEFAULT_COUNTRY_CODES);
export const yesNoEnum = z.enum(['yes', 'no']);

export const FIVE_DIGITS_COUNTRIES = ['FR', 'DE', 'IT', 'ES'] as const;
export const FIVE_DIGITS_REGEX = /^\d{5}$/;
export const DEFAULT_ZIPCODE_REGEX = /^.{3,10}$/;
export const EMAIL_REGEX = /^[^\s@:]+@[^\s@:]+\.[^\s@:]+$/;

// Italian legal identifier regexes — mirrors app/validators/italian-legal-form.js
export const IT_REA_NUMBER_REGEX = /^[a-zA-Z]{2}-?[0-9]+$/;
export const IT_CODICE_FISCALE_REGEX = /^[A-Z]{6}[0-9]{2}[A-Z]{1}[0-9]{2}[A-Z][0-9]{3}[A-Z]{1}$/;
export const IT_PARTITA_IVA_REGEX = /^[0-9]{11}$/;
// VAT may be prefixed with `IT` (case-insensitive); the form uppercases on submit.
export const IT_VAT_REGEX = /^(IT)?\d{11}$/i;
